import React from 'react';
import { Button } from '@mui/material';

const BackButton = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Button variant="contained" color="primary" onClick={handleGoBack}>
      Voltar
    </Button>
  );
};

export default BackButton;
